import * as React from "react";
import { ThemeProvider } from "@material-ui/core";
import { useMuiPortalTheme } from "./material.hooks";

export const PortalThemeProvider = ({ children }) => {
  const theme = useMuiPortalTheme();

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};
